import { render, staticRenderFns } from "./EnableIdentifiesUpdate.vue?vue&type=template&id=8a024a02&scoped=true&"
import script from "./EnableIdentifiesUpdate.vue?vue&type=script&lang=js&"
export * from "./EnableIdentifiesUpdate.vue?vue&type=script&lang=js&"
import style0 from "./EnableIdentifiesUpdate.vue?vue&type=style&index=0&id=8a024a02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a024a02",
  null
  
)

export default component.exports